import { render } from "./Testimonials.vue?vue&type=template&id=687fa9ae&scoped=true"
import script from "./Testimonials.vue?vue&type=script&setup=true&lang=js"
export * from "./Testimonials.vue?vue&type=script&setup=true&lang=js"

import "./Testimonials.vue?vue&type=style&index=0&id=687fa9ae&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687fa9ae"],['__file',"resources/js/frontend/components/Testimonials.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "687fa9ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('687fa9ae', __exports__)) {
    console.log('reload')
    api.reload('687fa9ae', __exports__)
  }
  
  module.hot.accept("./Testimonials.vue?vue&type=template&id=687fa9ae&scoped=true", () => {
    console.log('re-render')
    api.rerender('687fa9ae', render)
  })

}


export default __exports__